










import {
  defineComponent,
} from '@vue/composition-api';

import AdvSwiperBanner from '@/components/adv-components/adv-swiper-banner/index.vue';
import { AdvIdEnum } from '@/enums/advIdEnum';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';

const txxyUtbName = 'finance_taglessHome_txxyBanner';

export default defineComponent({
  components: {
    AdvSwiperBanner,
  },
  setup() {
    const onInit = (trackingParams: Dictionary) => {
      if (trackingParams) {
        ubtSetupModuleExpose(txxyUtbName, trackingParams);
      }
    };

    const indicatorChange = (trackingParams: Dictionary) => {
      if (trackingParams) {
        ubtSetupModuleExpose(txxyUtbName, trackingParams);
      }
    };

    const clickItem = (trackingParams: Dictionary) => {
      if (trackingParams) {
        ubtSetupPageButton(txxyUtbName, trackingParams);
      }
    };
    return {
      onInit,
      indicatorChange,
      clickItem,
      AdvIdEnum,
    };
  },
});
